<button mat-icon-button (click)="openDoc()">
    <mat-icon>help_outline</mat-icon>
</button>